import { AppBar, Grid } from "@mui/material";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { SocialNetworkIconButton } from "../appBarStyles";
import { FacebookUrl, InstagramUrl, YoutubeUrl } from "../../../helpers/clientConfigs";

export function SocialNetworkBar() {
    const openSite = (url: string) => {
        window.open(url, "_blank");
    }

    return (
        <AppBar elevation={0}
            sx={{
                backgroundColor: "appBar.background",
                color: "appBar.color",
                height: "auto",
                textAlign: "center",
                mt: "20px"
            }}
            position="static">
            <Grid>
                {FacebookUrl &&
                    <SocialNetworkIconButton onClick={() => openSite(FacebookUrl)}>
                        <FacebookIcon fontSize="large" />
                    </SocialNetworkIconButton>
                }
                {InstagramUrl &&
                    <SocialNetworkIconButton onClick={() => openSite(InstagramUrl)}>
                        <InstagramIcon fontSize="large" />
                    </SocialNetworkIconButton>}
                {YoutubeUrl &&
                    <SocialNetworkIconButton onClick={() => openSite(YoutubeUrl)}>
                        <YouTubeIcon fontSize="large" />
                    </SocialNetworkIconButton>
                }
            </Grid>
        </AppBar >
    );
}